import React from 'react'
import { usePagination, DOTS } from 'srcReact/helpers/hooks/usePagination'
import Icon from 'srcReact/components/icons/Icon'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import styles from './styles.module.scss'

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize = appConstantSettings.WORKPLACE_PAGINATION_QUANTITY,
    className
  } = props

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  let lastPage = paginationRange[paginationRange.length - 1]
  return (
    <ul className={`${styles.paginationWrapper} ${className}`}>
      <li className={`${styles.paginationItem} ${currentPage === 1 && styles.disabled}`} onClick={onPrevious}>
        <div className={`${styles.arrow} ${styles.left}`}>
          <Icon name='chevron-left24' size='small' />
        </div>
      </li>
      {paginationRange.map((pageNumber, idx) => {
        if (pageNumber === DOTS) {
          return (
            <li key={idx} className={`${styles.paginationItem} ${styles.dots}`}>
              &#8230;
            </li>
          )
        }

        return (
          <li
            key={idx}
            className={`${styles.paginationItem} ${pageNumber === currentPage && styles.selected}`}
            onClick={() => onPageChange(pageNumber)}>
            {pageNumber}
          </li>
        )
      })}
      <li className={`${styles.paginationItem} ${currentPage === lastPage && styles.disabled}`} onClick={onNext}>
        <div className={`${styles.arrow} ${styles.right}`}>
          <Icon name='chevron-right24' size='small' />
        </div>
      </li>
    </ul>
  )
}

export default Pagination
